(function () {

    "use strict";

    function IdsrvResourceOwnerService($http, $httpParamSerializerJQLike, $q, $log, options, TENANT) {

        var vm = this;

        vm.getToken = getToken;
        vm.revokeToken = revokeToken;

        function getToken(username, password) {

            return $q(function (resolve, reject) {

                var request = {
                    url: options.tokenUrl,
                    method: "POST",
                    data: $httpParamSerializerJQLike({
                        username: username,
                        password: password,
                        acr_values: "tenant:"+TENANT.URL,
                        grant_type: "password",
                        scope: "read write api"
                    }),
                    headers: {
                        'Authorization': 'Basic cm9jbGllbnQ6c2VjcmV0',
                        'Content-Type': "application/x-www-form-urlencoded"

                    }
                };
                $http(request).then(successCallback, errorCallback);

                function successCallback(response) {
                    $log.debug("Received access_token from STS.");
                    console.log(response);
                    resolve(response);
                }
                function errorCallback(error) {
                    $log.error("Error retrieving access_token from STS.");
                    $log.error(error);
                    reject(error);
                }
 
            });
        }

        function revokeToken(token) {

            return $q(function (resolve, reject) {

                var request = {
                    url: options.revokeUrl,
                    method: "POST",
                    data: $httpParamSerializerJQLike({
                        token: token,
                        token_type_hint: "access_token"
                    }),
                    headers: {
                        'Authorization': "Basic " + btoa(options.clientId + ":" + options.clientSecret),
                        'Content-Type': "application/x-www-form-urlencoded"
                    }
                };

                $http(request)
                    .success(function () {
                        $log.debug("Token revoked by STS.");
                        resolve();
                    })
                    .error(function () {
                        $log.error("Error revoking token in STS.");
                        reject();
                    });
            });
        }
    }

    function idsrvResourceOwnerServiceProvider() {

        var authBaseUrl = "";
        var client_id = "";
        var client_secret = "";

        var vm = this;

        vm.$get = ["$http", "$httpParamSerializerJQLike", "$q", "$log","URL","TENANT", serviceFactory];
        vm.useBaseUrl = useBaseUrl;
        vm.useClientId = useClientId;
        vm.useClientSecret = useClientSecret;

        function serviceFactory($http, $httpParamSerializerJQLike, $q, $log,URL, TENANT) {

            if (!authBaseUrl) {
                throw new Error("identityServerAuthorizationServiceProvider: authBaseUrl could not be empty.");
            }

            if (!client_id) {
                throw new Error("identityServerAuthorizationServiceProvider: clientId could not be empty.");
            }

            if (!client_secret) {
                throw new Error("identityServerAuthorizationServiceProvider: clientSecret could not be empty.");
            }

            var options = {             
                tokenUrl: URL.URL+"/auth/connect/token",
                
                revokeUrl: URL.URL+"/auth/connect/revocation",
                clientId: client_id,
                clientSecret: client_secret
            };

            return new IdsrvResourceOwnerService($http, $httpParamSerializerJQLike, $q, $log, options, TENANT);
        }

        function useBaseUrl(baseUrl) {
            authBaseUrl = baseUrl;
        }

        function useClientId(clientId) {
            client_id = clientId;
        }

        function useClientSecret(clientSecret) {
            client_secret = clientSecret;
        }

    }

    angular.module("sphForms.auth")
        .provider("sphForms.idsrvResourceOwnerService", idsrvResourceOwnerServiceProvider);

})();